import React from 'react';
import './ServiceView.css';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import {ButtonScroll, ButtonReturn} from '../ButtonSquare';
import logoComdeslezards from './assets/img/logo_comdeslezards.png';
import { ButtonText } from '../ButtonSquare';
import TechnologiesBlock from '../TechnologiesBlock';
import ReactMarkdown from 'react-markdown';


const ServiceView = (props) => {
  const markdown = '# This is a header\n\nAnd this is a paragraph';
  const {picture, title, description, technologies} = props;
  return (
    <div>
      <Helmet title={`${title} - Com des Lézards`}/>
      <Link to="/">
        <img
          className="logo"
          src={logoComdeslezards}
          alt="logo comdeslézards com des lézards"/>
      </Link>
      <div className="serviceview_returnbutton">
        <ButtonReturn/>
      </div>
      <div className="serviceview_container">
        <div className="serviceview_picture">
          <img src={picture} alt=""/>
        </div>
        <div className="serviceview_infos">
          <h1>
            {title}
          </h1>
          <div className="serviceview_infos_description">
            <ReactMarkdown source={description}/>
          </div>
          <div style={{display: 'flex', justifyContent: 'center'}}>
          <ButtonText link="#contact">
          Nous contacter
        </ButtonText>
          </div>
          <div className="delimiter"/>
          <TechnologiesBlock technologies={technologies}/>
        </div>
      </div>
      <div className="serviceview_scroll_button">
        <ButtonScroll link="#références"/>
      </div>
    </div>
  );
};

ServiceView.propTypes = {
  picture: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  technologies: PropTypes
    .arrayOf(PropTypes.string)
    .isRequired
};

export default ServiceView;



// WEBPACK FOOTER //
// ./src/components/ServiceView/ServiceView.jsx